import { createTheme } from '@mui/material/styles'
import { colorWithOpacity } from './AppHelper'
import { ENV } from '../ENV'

export const theme = createTheme({
  typography: {
    fontFamily: 'Manrope'
  },
  palette: {
    primary: {
      main: ENV.colors.primary_color
    },
    background: {
      default: ENV.colors.default_color,
      paper: ENV.colors.paper_color
    },
    text: {
      primary: ENV.colors.primary_text,
      secondary: ENV.colors.primary_medium_text,
      disabled: ENV.colors.primary_small_text,
      opposite: ENV.colors.secondary_text,
      error: ENV.colors.red,
      success: ENV.colors.green,
      yellow: ENV.colors.yellow,
      blue: ENV.colors.blue
    },
    divider: colorWithOpacity(ENV.colors.primary_text, 0.1),
    border: {
      main: ENV.colors.stroke
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            color: ENV.colors.primary_text,
            borderRadius: '8px',
            backgroundColor: ENV.colors.paper_color
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: ENV.colors.paper_color
        }
      }
    }
  }
})
